import type { ReactNode } from 'react';

export type BannerTone = 'info' | 'warning' | 'error' | 'success';

const tones: Record<BannerTone, string> = {
  info: 'bg-yellow-soft text-ink border-yellow',
  warning: 'bg-white text-warning-text border-warning',
  error: 'bg-white text-error-text border-error',
  success: 'bg-green-soft text-success-text border-success',
};

export function Banner({ tone = 'info', children, action }: { tone?: BannerTone; children: ReactNode; action?: ReactNode }) {
  return (
    <div role={tone === 'error' ? 'alert' : 'status'} className={`flex items-center justify-between gap-4 rounded-md border px-4 py-2 text-sm ${tones[tone]}`}>
      <div>{children}</div>
      {action}
    </div>
  );
}
